export default __webpack_public_path__ + "static/web20230530-f5bff62af6e71ae08cabccd09cbb3fb4.png";